import styled, { keyframes } from 'styled-components';

import { floorGameEasing as easing, styledMedia, styledReset } from '@pkg/primitives';

import { tokens } from './tokens';
import { MarqueeArrowsDirection } from './types';

interface StyledMarqueeArrowsProps {
    $direction?: MarqueeArrowsDirection;
}

const pulseAnimation = keyframes`
    from {
        opacity: 0.2
    }
    to {
        opacity: 1
    }
`;

export const StyledMarqueeArrows = styled.ul<StyledMarqueeArrowsProps>`
    ${styledReset.borderBox};
    ${styledReset.list};
    display: flex;
    min-height: ${tokens.wrapper.minHeight}px;
    height: 100%;
    rotate: ${({ $direction }) => ($direction === MarqueeArrowsDirection.Left ? '180deg' : undefined)};
`;

export const StyledArrow = styled.li`
    flex: 0 0 auto;
    height: 100%;
    animation: ${pulseAnimation} ${tokens.animation.duration}ms ${easing.cubic} infinite alternate both;

    svg {
        ${styledMedia.svgBase};
    }

    &:nth-child(2) {
        animation-delay: ${tokens.animation.delay}ms;
    }

    &:nth-child(3) {
        animation-delay: ${tokens.animation.delay * 2}ms;
    }
`;
